import { render, staticRenderFns } from "./SupportArticle.vue?vue&type=template&id=ea8de660&scoped=true&"
import script from "./SupportArticle.vue?vue&type=script&lang=js&"
export * from "./SupportArticle.vue?vue&type=script&lang=js&"
import style0 from "./SupportArticle.vue?vue&type=style&index=0&id=ea8de660&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea8de660",
  null
  
)

export default component.exports